// frontend/src/utils/memberValidationUtils.js

import MEMBER_VALIDATION_CONFIG from '../config/memberValidation'
import { ID_VALIDATION_CONFIG } from '../config/idValidation'

/**
 * Determina si debe mostrarse advertencia de edad esperada.
 * @param {string} birthdate - Fecha de nacimiento en formato YYYY-MM-DD.
 * @returns {boolean}
 */
export function shouldShowAgeWarning(birthdate) {
  if (!birthdate) return false

  const birthDate = new Date(birthdate)
  if (isNaN(birthDate.getTime())) return false

  const today = new Date()
  let age = today.getFullYear() - birthDate.getFullYear()
  const monthDiff = today.getMonth() - birthDate.getMonth()
  const dayDiff = today.getDate() - birthDate.getDate()
  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) age--

  const { expectedMax, absoluteMax } = MEMBER_VALIDATION_CONFIG.age
  return age > expectedMax && age <= absoluteMax
}

/**
 * Verifica si la fecha de nacimiento está fuera del rango permitido.
 * @param {string} birthdate - Fecha de nacimiento en formato YYYY-MM-DD.
 * @returns {boolean}
 */
export function shouldShowInvalidBirthdate(birthdate) {
  if (!birthdate) return true

  const birthDate = new Date(birthdate)
  if (isNaN(birthDate.getTime())) return true

  const today = new Date()
  let age = today.getFullYear() - birthDate.getFullYear()
  const monthDiff = today.getMonth() - birthDate.getMonth()
  const dayDiff = today.getDate() - birthDate.getDate()
  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) age--

  const { min, absoluteMax } = MEMBER_VALIDATION_CONFIG.age
  return age < min || age > absoluteMax
}

/**
 * Determina si debe mostrarse el banner de cédula inválida.
 * @param {string} rawNationalId - Cédula digitada por el usuario.
 * @returns {boolean}
 */
export function shouldShowInvalidBanner(rawNationalId) {
  const raw = rawNationalId || ''
  const cleaned = raw.replace(/\D/g, '')
  const config = ID_VALIDATION_CONFIG.validators[ID_VALIDATION_CONFIG.activeCountry]

  if (!config || raw.length === 0) return false

  const failsPattern = config.allowedPattern && !config.allowedPattern.test(raw)
  const isShort = cleaned.length < config.nationalIdLength
  const isTooLong = cleaned.length > config.nationalIdLength
  const isInvalid = cleaned.length === config.nationalIdLength && config.validate
    ? !config.validate(cleaned)
    : false

  return failsPattern || isShort || isTooLong || isInvalid
}
